import * as React from "react";
import Loadable from "react-loadable";
import { RouteComponentProps } from "react-router-dom";

import { LOADABLE_COMPONENT_DELAY } from "@config/consts";

import { PageSkeleton } from "./Booking.skeletons";

const LoadableHomeCleaning: any = Loadable({
  loader: () => import("./HomeCleaning/HomeCleaning"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.HomeCleaning;
    return <Component {...props} />;
  },
  loading: PageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const Booking = (props: RouteComponentProps): React.ReactElement => (
  <LoadableHomeCleaning {...props} />
);

export { Booking };
